import React from 'react';

const SpeechBubble = ({ className = "", text = "!" }) => (
  <svg className={className} width="80" height="60" viewBox="0 0 80 60" fill="none">
    <ellipse cx="40" cy="25" rx="30" ry="20" stroke="currentColor" strokeWidth="2.5" fill="none"/>
    <path d="M35 40 L 30 50 L 38 42" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
    <text x="40" y="30" textAnchor="middle" fontSize="20" fontWeight="bold" fill="currentColor">{text}</text>
  </svg>
);

export default SpeechBubble;